export default __webpack_public_path__ + "static/media/X900.78d91808.jpg";